import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import {
  AgrPageToolbarModule,
  AgrResponsiveActionsModule,
  AgrFilterModule,
} from '@next/core-lib/components';
import { provideEffects } from '@ngrx/effects';

import LegendComponent from './legend/legend.component';
import { OverviewComponent } from './overview.component';
import { OverviewEffects } from './store/effects';
import { CopyAdviceModule } from '../copy-advice/copy-advice.module';
import { SharedModule } from '../shared/shared.module';

@NgModule({
  declarations: [OverviewComponent, LegendComponent],
  imports: [
    SharedModule,
    AgrPageToolbarModule,
    AgrResponsiveActionsModule,
    AgrFilterModule,
    MatListModule,
    MatIconModule,
    MatButtonModule,
    MatInputModule,
    MatTooltipModule,
    MatCheckboxModule,
    RouterModule,
    MatToolbarModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    CopyAdviceModule,
  ],
  providers: [provideEffects(OverviewEffects)],
})
export class OverviewModule {}
